module.exports = __webpack_public_path__ + "img/IMG_4215_L_Black.39c7ebba.jpg";